import * as React from "react";
import styled from "styled-components";
import { DefaultFontStack } from "../typography/typography";
import Link from "../link/link";

const Trigger = styled(Link)`
  all: unset;
  ${DefaultFontStack}
  color: ${(props) => props.theme.colors.highEmphasis};
  font-size: 17px;
  line-height: 30px;
  letter-spacing: 0.5px;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  display: block;
  color: ${({ theme }) => theme.colors.mediumEmphasis};

  &:hover {
    background-color: ${({ theme }) => theme.colors.ice};
  }
`;

function NavigationLink(props) {
  const { item } = props;
  return <Trigger url={item.url}>{item.text}</Trigger>;
}

export default NavigationLink;
